// extracted by mini-css-extract-plugin
export var ProjectsWrapper = "Projects-module--ProjectsWrapper--2keOr";
export var SliderWrapper = "Projects-module--SliderWrapper--3WCMu";
export var Buttons = "Projects-module--Buttons--2Utdc";
export var RightArrow = "Projects-module--RightArrow--1akyD";
export var CustomParagraph = "Projects-module--CustomParagraph--5DLYz";
export var Slider = "Projects-module--Slider--2xSCp";
export var SliderItem = "Projects-module--SliderItem--2bDwl";
export var ImageContainer = "Projects-module--ImageContainer--wZa9k";